module.exports = __webpack_public_path__ + "static/media/g2mlogo.3e5c517a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Application/Header/Assets/g2mlogo.svg
// module id = 941
// module chunks = 0